import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          productId: Yup.string()
                                                        .required('Required'),
                                          applicationProductStatus: Yup.string()
                                                                       .required('Required'),
                                      });
